import { Typography } from "@hellocarbo/lasagne";
import { cn } from "@hellocarbo/lasagne/utils";
import { Check } from "lucide-react";

type FeatureListProps = {
  items: string[];
  className?: string;
};

const FeatureList = ({ items, className, ...props }: FeatureListProps) => {
  return (
    <ul className={cn("space-y-xs", className)} {...props}>
      {items.map((item, index) => {
        return (
          <li key={`${item}-${index}`} className="gap-sm flex items-start">
            <Check className="text-positive shrink-0" />
            <Typography> {item} </Typography>
          </li>
        );
      })}
    </ul>
  );
};

export default FeatureList;
